import styled from 'styled-components';

export const StyledTabsWrapper = styled.div`
  min-height: calc(100vh - 150px);
  width: 100%;
  padding: 20px;
  background-color: #fff;
  border: 1px solid #E5E5E5;
  border-radius: 5px;
  box-shadow: 0 2px 4px #C4C4C4;
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 350px 1fr;
  @media screen and (max-width: 992px) {
    min-height: 100%;
    padding: 0;
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
    background-color: transparent;
    border: none;
    border-radius: 0;
    box-shadow: none;
  }
`;

export const StyledTabsHead = styled.div`
  padding-right: 20px;
  ${({orientation}) => orientation === 'horizontal' ? 'border-right: none' : 'border-right: 1px solid #E5E5E5'};
  ${({orientation}) => orientation === 'horizontal' && 'border-bottom: 1px solid #E5E5E5'};
  .tab-head__title {
    margin-bottom: 20px;
    padding: 20px;
    color: #277661;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    border-bottom: 1px solid #E5E5E5;
    @media screen and (max-width: 576px) {
      font-size: 14px;
    }
  }
  .tab-head-buttons {
    & > span {
      background-color: #F5F4FA;
    }
    button {
      max-width: 100%;
      padding: 16px 12px;
      font-size: 16px;
      font-family: 'Open Sans', sans-serif;
      letter-spacing: inherit;
      font-weight: 600;
      text-transform: capitalize;
      transition: all .3s ease;
      ${({orientation}) => orientation === 'horizontal' && 'border-bottom: 3px solid transparent'};
      ${({orientation}) => orientation === 'horizontal' && 'text-transform: uppercase'};
      &:hover {
        background-color: #F5F4FA;
      }
    }
    button.Mui-selected {
      color: #277661;
      ${({orientation}) => orientation === 'horizontal' && 'border-color: #29c59c'};
      ${({orientation}) => orientation !== 'horizontal' && 'background-color: #F5F4FA'};
      &:before {
        display: none;
      }
    }
    .MuiTabs-indicator {
      display: none;
      background-color: #277661;
    }
  }
  @media screen and (max-width: 992px) {
    ${({orientation}) => orientation !== 'horizontal' && `
      padding: 20px;
      background-color: #fff;
      border: 1px solid #E5E5E5;
      border-radius: 5px;
      box-shadow: 0 2px 4px #C4C4C4;
    `};
  }
  @media screen and (max-width: 576px) {
    ${({orientation}) => orientation !== 'horizontal' &&  'padding: 15px;'};
    .tab-head-buttons button {
      padding: 12px;
      font-size: 14px;
    }
  }
`;

export const StyledHeadLinks = styled.div`
  display: grid;
  .tab-head__link_current {
    color: #277661;
    background-color: #F5F4FA;
    opacity: 1;
    &:hover {
      color: #277661;
    }
  }
`;
export const StyledTabLink = styled.button`
  max-width: 100%;
  padding: 20px 12px;
  font-size: 16px;
  font-family: 'Open Sans', sans-serif;
  letter-spacing: inherit;
  font-weight: 600;
  text-align: center;
  text-transform: capitalize;
  transition: all .3s ease;
  opacity: 0.7;
  &:hover {
    color: inherit;
    background-color: #F5F4FA;
  }
  @media screen and (max-width: 576px) {
    padding: 14px;
    font-size: 14px;
  }
`;

export const StyledTabsBody = styled.div`
  width: 100%;
  overflow-x: auto;
  @media screen and (max-width: 992px) {
    padding: 20px;
    background-color: #fff;
    border: 1px solid #E5E5E5;
    border-radius: 5px;
    box-shadow: 0 2px 4px #C4C4C4;
  }
  @media screen and (max-width: 599px) {
    padding: 20px 15px;
  }
`;

export const StyledSeparator = styled.div`
  height: 1px;
  margin: 20px 0;
  background-color: #E5E5E5;
`;
